<template>
  <v-container
    id="towerServices"
    fluid
    tag="section"
  >
    <v-card
      class="mx-4 px-4 py-4"
    >
      <v-container>
        <v-row>
          <v-col>
            <v-btn
              @click="doGetWirelessServices"
            >
              Refresh
            </v-btn>
            <v-btn
              tile
              color="success"
              @click="doGetALlStats"
            >
              Get ALL stats
            </v-btn>
            <v-btn
              tile
              color="success"
              @click="doTriggerAllImports"
            >
              Trigger all radios to import
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <h1>FAILED Customers</h1>
      <v-data-table
        :headers="headersCustomers"
        :items="failedCustomers"
        :items-per-page="3000"
        item-key="tempkey"
        sort-by="Id"
        class="elevation-1"
      >
        <template v-slot:item.cust_name="{ item }">
          <a
            :href="'https://pow.velociter.net/record.php?id=' + item.cust_id"
            target="_blank"
          >{{ item.cust_id + ' - ' + item.cust_name }}</a>
        </template>
        <template v-slot:item.wireless_ip="{ item }">
          <a
            :href="'http://' + item.wireless_ip"
            target="_blank"
          >{{ item.wireless_ip }}</a>
        </template>

        <template v-slot:item._bearing="{ item }">
          {{ item._bearing }}
        </template>
        <template v-slot:item._distance="{ item }">
          {{ item._distance }}
        </template>
        <template v-slot:item._ccValue="{ item }">
          <v-btn
            tile
            color="success"
            @click="doGetSMStats(item)"
          >
            Get STATS
          </v-btn> <br />
          {{ item._ccValue }}
          <v-btn
            @click="doTriggerConfigImport(item)"
          >
            Import Config
          </v-btn>
          <v-btn
            color="warning"
            @click="doTriggerReboot(item)"
          >
            Reboot
          </v-btn>
        </template>
        <template v-slot:item.wc_last_contact="{ item }">
          {{ formatDate(item.wc_last_contact, 'YYYY-MM-DD HH:mm:ss', true) }}
          <div
            v-for="stat of item._stats"
            :key="stat.display_text"
          >
              <span style="font-weight: bold">
                {{ stat.display_text}}
              </span>
            <span>
                {{ stat.value }}
              </span>
          </div>
        </template>
        <template v-slot:item.wc_last_downloaded="{ item }">
          {{ formatDate(item.wc_last_downloaded, 'YYYY-MM-DD HH:mm:ss', true) }}
        </template>
        <template v-slot:item._lastStats="{ item }">
          <div
            v-for="stat of item._lastStats"
            :key="stat.display_text"
          >
              <span style="font-weight: bold">
                {{ stat.display_text}}
              </span>
            <span>
                {{ stat.value }}
              </span>
          </div>
        </template>
      </v-data-table>
      <h1>ALL Customers</h1>
      <v-data-table
        :headers="headersCustomers"
        :items="customers"
        :items-per-page="3000"
        item-key="tempkey"
        sort-by="Id"
        class="elevation-1"
      >
        <template v-slot:item.cust_name="{ item }">
          <a
            :href="'https://pow.velociter.net/record.php?id=' + item.cust_id"
            target="_blank"
          >{{ item.cust_id + ' - ' + item.cust_name }}</a>
        </template>
        <template v-slot:item.wireless_ip="{ item }">
          <a
            :href="'http://' + item.wireless_ip"
            target="_blank"
          >{{ item.wireless_ip }}</a>
        </template>

        <template v-slot:item._bearing="{ item }">
          {{ item._bearing }}
        </template>
        <template v-slot:item._distance="{ item }">
          {{ item._distance }}
        </template>
        <template v-slot:item._ccValue="{ item }">
          <v-btn
            tile
            color="success"
            @click="doGetSMStats(item)"
          >
            Get STATS
          </v-btn> <br />
          {{ item._ccValue }}
          <v-btn
            @click="doTriggerConfigImport(item)"
          >
            Import Config
          </v-btn>
          <v-btn
            color="warning"
            @click="doTriggerReboot(item)"
          >
            Reboot
          </v-btn>
        </template>
        <template v-slot:item.wc_last_contact="{ item }">
          {{ formatDate(item.wc_last_contact, 'YYYY-MM-DD HH:mm:ss', true) }}
          <div
            v-for="stat of item._stats"
            :key="stat.display_text"
          >
              <span style="font-weight: bold">
                {{ stat.display_text}}
              </span>
            <span>
                {{ stat.value }}
              </span>
          </div>
        </template>
        <template v-slot:item.wc_last_downloaded="{ item }">
          {{ formatDate(item.wc_last_downloaded, 'YYYY-MM-DD HH:mm:ss', true) }}
        </template>
        <template v-slot:item._lastStats="{ item }">
            <div
              v-for="stat of item._lastStats"
              :key="stat.display_text"
            >
              <span style="font-weight: bold">
                {{ stat.display_text}}
              </span>
              <span>
                {{ stat.value }}
              </span>
            </div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  // import { mapGetters } from 'vuex'
  import moment from '../../../assets/js/moment.min'
  import PowCustomerService from '../../../services/pow-customer.service'
  import Pow450SmService from '../../../services/pow-450sm.service'

  export default {
    name: 'TowerCustomers',

    data () {
      return {
        selectedAccount: {},
        page: 1,
        filter: {},
        sortBy: 'created_at',
        optionsSoryBy: [
          'rowkey',
          'created_at',
        ],
        customers: [],
        failedCustomers: [],
        headersCustomers: [
          {
            text: 'Customer',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'cust_name',
          },
          {
            text: 'IP',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'wireless_ip',
          },
          {
            text: 'Mac',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'wireless_mac',
          },
          {
            text: 'Tower',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'tower_name',
          },
          {
            text: 'AP',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'wireless_ap',
          },
          {
            text: 'Bearing',
            align: 'start',
            sortable: true,
            groupable: false,
            value: '_bearing',
          },
          {
            text: 'Distance',
            align: 'start',
            sortable: true,
            groupable: false,
            value: '_distance',
          },
          {
            text: 'Potential APs',
            align: 'start',
            sortable: true,
            groupable: false,
            value: '_apString',
          },
          {
            text: 'Current CC',
            align: 'start',
            sortable: true,
            groupable: false,
            value: '_ccValue',
          },
          {
            text: 'Last Contact',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'wc_last_contact',
          },
          {
            text: 'Config DL\'d',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'wc_last_downloaded',
          },
          {
            text: 'LKS',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'last_known_sig',
          },
          {
            text: 'LAST CC',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'wc_last_cc',
          },
          {
            text: 'Last Stats',
            align: 'start',
            sortable: true,
            groupable: false,
            value: '_lastStats',
          },
        ],

        itemsPerPageArray: [50, 100, 250, 500, 1000],
      }
    },
    computed: {
    },
    async created () {
      console.log('page loaded')
      console.log(this.$route)
      // if (this.$route.params.account) {
      //   this.selectedAccount = this.$route.params.account
      // } else if (this.$route.params.key) {
      //   const payload = {
      //     key: this.$route.params.key,
      //     params: this.$route.query,
      //   }
      //   this.selectedAccount = await this.getAccount(payload)
      // }
      await this.doGetWirelessServices()
    },
    mounted () {

      // const queryParams = this.$route.params
    },
    methods: {
      async doGetWirelessServices () {
        try {
          const params = {
            format: 'json',
            filters: {
              towerNumber: {
                value: [
                  111,
                ],
              },
              apType: {
                value: [
                  '450',
                  '450m',
                ],
              },
              active: {
                value: [
                  'y',
                ],
              },
            },
            generateConfig: true,
          }
          const { data } = await PowCustomerService.mapServices(params)
          console.log(data)
          this.customers = data
        } catch (e) {
          console.log(e)
        }
      },
      async doGetSMColorCode (entry) {
        try {
          const entryIndex = this.customers.findIndex(c => c.tempkey === entry.tempkey)
          const ccResult = await Pow450SmService.getCurrentCC({
            ip: entry.wireless_ip,
            updateConfig: true,
          })
          console.log('CC result:', ccResult.data)
          console.log('Entry Index:', entryIndex)
          const currectCC = ccResult.data[0]._value
          this.customers[entryIndex]._ccValue = currectCC
          return currectCC
        } catch (e) {
          console.log(e)
          return false
        }
      },
      async doGetSMStats (entry) {
        try {
          const entryIndex = this.customers.findIndex(c => c.tempkey === entry.tempkey)
          const ccResult = await Pow450SmService.getCurrentStats({
            ip: entry.wireless_ip,
            updateConfig: true,
          })
          console.log('Stats result:', ccResult.data)
          // console.log('Entry Index:', entryIndex)
          const currentStats = ccResult.data
          this.customers[entryIndex]._lastStats = currentStats
          for (let i = 0; i < currentStats.length; i++) {
            // eslint-disable-next-line camelcase
            const { display_text, value } = currentStats[i]
            // eslint-disable-next-line camelcase
            if (display_text === 'Signal') {
              this.customers[entryIndex]._lks = value
            }
          }
          return currentStats !== 'timeout'
        } catch (e) {
          console.log(e)
          return false
        }
      },
      async doTriggerConfigImport (entry) {
        try {
          // const entryIndex = this.customers.findIndex(c => c.tempkey === entry.tempkey)
          const importResult = await Pow450SmService.triggerConfigImport({
            ip: entry.wireless_ip,
          })
          console.log('Config Import result:', importResult.data)
          // console.log('Entry Index:', entryIndex)
          return true
        } catch (e) {
          console.log(e)
          return false
        }
      },
      async doTriggerReboot (entry) {
        try {
          // const entryIndex = this.customers.findIndex(c => c.tempkey === entry.tempkey)
          const importResult = await Pow450SmService.triggerReboot({
            ip: entry.wireless_ip,
          })
          console.log('Reboot Radio result:', importResult.data)
          // console.log('Entry Index:', entryIndex)
          return true
        } catch (e) {
          console.log(e)
          return false
        }
      },
      async doScanColorCodes () {
        console.log('Getting all ColorCodes...')
        let colorCount = 0
        let colorFails = 0
        for (let i = 0; i < this.customers.length; i++) {
          console.log(`Processing position ${i} of ${this.customers.length}`)
          const cust = this.customers[i]
          const colorCode = await this.doGetSMColorCode(cust)
          if (colorCode > 0) {
            colorCount++
          } else {
            this.failedCustomers.push(cust)
            colorFails++
          }
        }
        console.log('Finished getting color codes!')
        console.log(`${colorCount} successful AND ${colorFails} timeouts`)
      },
      async doGetALlStats () {
        console.log('Getting all Stats...')
        let colorCount = 0
        let colorFails = 0
        for (let i = 0; i < this.customers.length; i++) {
          console.log(`Processing position ${i} of ${this.customers.length}`)
          const cust = this.customers[i]
          const stats = await this.doGetSMStats(cust)
          if (stats) {
            colorCount++
          } else {
            this.failedCustomers.push(cust)
            colorFails++
          }
        }
        console.log('Finished getting color codes!')
        console.log(`${colorCount} successful AND ${colorFails} timeouts`)
      },
      async doTriggerAllImports () {
        console.log('Configuring all radios...')
        this.failedCustomers = []
        let colorCount = 0
        let colorFails = 0
        for (let i = 0; i < this.customers.length; i++) {
          console.log(`Processing position ${i} of ${this.customers.length}`)
          const cust = this.customers[i]
          const colorCode = await this.doTriggerConfigImport(cust)
          if (colorCode > 0) {
            colorCount++
          } else {
            this.failedCustomers.push(cust)
            colorFails++
          }
          await this.sleep(100)
        }
        console.log('Finished getting importing config files!')
        console.log(`${colorCount} successful imports AND ${colorFails} timeouts`)
      },
      async doTriggerAllReboots () {
        console.log('Rebooting all radios...')
        this.failedCustomers = []
        let colorCount = 0
        let colorFails = 0
        for (let i = 0; i < this.customers.length; i++) {
          console.log(`Processing position ${i} of ${this.customers.length}`)
          const cust = this.customers[i]
          const colorCode = await this.doTriggerReboot(cust)
          if (colorCode > 0) {
            colorCount++
          } else {
            this.failedCustomers.push(cust)
            colorFails++
          }
          await this.sleep(100)
        }
        console.log('Finished rebooting radios!')
        console.log(`${colorCount} successful reboots AND ${colorFails} timeouts`)
      },
      async sleep (ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
      },
      formatDate (value, format, utc) {
        if (!format) {
          format = 'M/D/YYYY'
        }
        if (utc) {
          return moment.utc(value).format(format)
        } else {
          return moment(value).format(format)
        }
      },

    },
  }
</script>
